/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { loadMessages as e } from "./loadMessages.mjs";
const n = (o) => {
  const { data: r, language: a, children: t } = o;
  return a && e(r, a), t;
};
export {
  n as LocalizationDataProvider
};
